import MuiMenu, { MenuProps } from "@mui/material/Menu";
import { handleKeyDown } from "core/model/accessibility/keyboardActions";
import { Z_INDEX_MUI_MENU } from "ds_legacy/materials/metrics";

type SlotPropsWithSx = { sx?: Record<string, unknown> };

export const Menu = ({
  children,
  onClick,
  onClose,
  slotProps,
  ...props
}: MenuProps) => {
  const paperSlot = slotProps?.paper as SlotPropsWithSx | undefined;
  const rootSlot = slotProps?.root as SlotPropsWithSx | undefined;
  return (
    <MuiMenu
      {...props}
      autoFocus={true}
      slotProps={{
        paper: {
          ...slotProps?.paper,
          sx: { zIndex: Z_INDEX_MUI_MENU, ...paperSlot?.sx },
        },
        root: {
          ...slotProps?.root,
          sx: { zIndex: Z_INDEX_MUI_MENU, ...rootSlot?.sx },
        },
      }}
      tabIndex={0}
      TransitionProps={{
        onKeyDown: handleKeyDown({
          onCancel: (event) => {
            onClose?.(event, "escapeKeyDown");
          },
          onConfirm: (event) => {
            onClick?.(
              event as unknown as React.MouseEvent<HTMLDivElement, MouseEvent>,
            );
          },
        }),
      }}
      onClick={onClick}
      onClose={onClose}
    >
      {children}
    </MuiMenu>
  );
};
